module.exports = __webpack_public_path__ + "media/images/icons/clock-1f36e9b916e92b3d779cc4af376d42fe.svg";